import React from 'react';
import certificateFlowImg from "../../assets/images/certificateFlow.png"
import style from "./index.module.css"

const CertificateFlow = () => {
    return (
        <div>
            <div className={style.articleTitle}>
                产品认证流程
            </div>
            <div className={style.pictureContainer}>
                <img style={{width:'100%',height:"100%"}} src={certificateFlowImg} alt=""/>
            </div>
        </div>
    );
};

export default CertificateFlow;